const tableOfContentModule = {

    insertExpandBlock() {


        $('.div-anchor .anchor').after(`
            <div class="expand-block">
                <span>${translates.expand}</span>
                <svg width="19" height="11" viewBox="0 0 19 11" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.90039 2.19995L9.50039 9.53328L17.1004 2.19995" stroke="#76808F"
                          stroke-width="1.36901" stroke-linecap="round"/>
                </svg>
            </div>
        `);
    },

    calculateItemsHeight(isCollapsed = false) {
        let tableOfContentLisHeight = 0;
        const tableOfContentLis = $('.anchor li');

        if (isCollapsed) {
            const countTableOfContentItemsToShow = 4;

            tableOfContentLis.each(function (i, li) {
                if (i < countTableOfContentItemsToShow) {
                    tableOfContentLisHeight += $(li).height() + 16;
                }
            })
        } else {
            tableOfContentLis.each(function (i, li) {
                tableOfContentLisHeight += $(li).height() + 16;
            })
        }

        return tableOfContentLisHeight;
    },

    // Высчитывает высоту таблица оглавления
    setHeightOfTable() {
        // Кнопка Развернуть в оглавлении
        const countTableOfContentItemsToShow = 3;
        const tableOfContentLis = $('.anchor li');

        $('.div-anchor .anchor').css('max-height', this.calculateItemsHeight(true) + 'px')

        const countOfLi = tableOfContentLis.length;
        if (countOfLi > countTableOfContentItemsToShow) {
            $('.div-anchor .expand-block').css('display', 'flex')
        }
    },

    // Запускает слушатель событий
    initEvents() {
        $(document).on('click', '.div-anchor .expand-block', function (e) {
            const parent = $(this).closest('.div-anchor');
            parent.toggleClass('anchor-open');

            if (parent.hasClass('anchor-open')) {
                $(this).find('span').text(translates.collapse);
                $('.anchor').css('max-height', tableOfContentModule.calculateItemsHeight() + 'px')
            } else {
                $(this).find('span').text(translates.expand);
                $('.anchor').css('max-height', tableOfContentModule.calculateItemsHeight(true) + 'px')
            }
        })

        // $(window).resize(() => {
        //     this.setHeightOfTable();
        // });
    },

    // Инициализация оглавления
    init() {
        this.insertExpandBlock();
        this.setHeightOfTable();
        this.initEvents();

        setTimeout(() => {
            if (+$('[name="isCollapseHeadTable"]').val() === 0) {
                $('.div-anchor .expand-block').click();
            }
        }, 100)
    }
};

export default tableOfContentModule;
